export default "__VITE_ASSET__f68020ea__"